import React from 'react';
import './Booking.css'
import NavDock from '../Components/Layout/NavDock';

import RegisterForm from '../Components/Layout/RegisterForm';

const Booking = () => {
    return ( 
        <main className='Booking'>
            <div className='TopBar'></div>
            <div className='MainBooking'>
                <RegisterForm />
            </div>
            <NavDock/>
        </main>
     );
}
 
export default Booking;